import Vue from "vue";
import Vuex from "vuex";

import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

import * as actionsWebRTC from './actions-webrtc'

import { createPerson, createObject, choice, randint } from '@/utils.js'

/*import { randomColor } from 'randomcolor'*/ //Vue

//let colors = ['#38B7FF', '#FBFF38', '#C566FF', '#85FF66', '#FF66E7', '#FFAF66', '#FF5656', '#56FFE1', '#B1CCFF', '#C33E76', '#91C500', '#00CD77', '#10F1FF', '#F2EFE7']
let colors = ['#38B7FF', '#2C8DFF', '#593EFF', '#904BFF', '#E964FF', '#FF669D', '#FF515B', '#FF8450', '#FFAC60', '#CDD02B', '#91C500', '#00CD77', '#00D0C4', '#C33E76']
// let colors = ['#F37121', '#00AEEF', '#FAA61E', '#D0181F', '#CCCA5D'] // PHOENIX DESIGN WEEK

/*
#F37121
#00AEEF
#FAA61E
#D0181F
#CCCA5D
#939589 */

Vue.use(Vuex)

const state = {
	audioContext: null,
	emptyStream: null, // let emptyStream = "MediaStream" in window ? new MediaStream(): null;

	webAudioOutputStream: null,
	combinedOutputStream: null,

	view: {
		x: 0,
		y: 0,
		width: 0,
		height: 0
	},

	objectMode: 0,
	// objectMode 0 -> objects draggable
	// objectMode 1 -> object dragging disabled
	// objectMode 2 -> object dragging disabled, opacity lowered, and ignore mouse (room mode)

	connected: false,
	groupID: '',

	menu: null, // because this property cannot be directly on the objects (reordering messes up props)

	self: createPerson({ color: choice(colors), order: Date.now(), x: randint(-50, 50), y: randint(-50, 50) }),

	boombox: createObject({
		playing: false,
		playlist: [
			//{ title: "My Neighbor Totoro", video_id: "RUnvkHZwDg4" }
		],
		current: null
	}),

	rooms: [
		/*{
			id: 1,
			name: "",
			x: -250,
			y: -150,
			width: 500,
			height: 300,
			//texture: require('../image.png')
		},*/
		/*{
			x: 50,
			y: -100,
			width: 300,
			height: 300,
			//texture: require('../image.png')
		}*/
	],

	//objects: {},
	objects: [],

	peers: {}
}

export default new Vuex.Store({
	state,
	getters,
	actions: Object.assign({}, actions, actionsWebRTC),
	mutations,
})